import { DocumentList, Loader } from '@components';
import { EDocuments } from '@features/api/response/tabContent/EDocuments';
import { TabType } from '@features/api/response/tabContent/TabType';
import { useTabData } from '@hooks/useTabData';
import { Container } from './EDocument.styles';

const EDocument: React.FC<any> = ({ type }: { type: TabType }) => {
  const {
    data: documents,
    isFetching,
    isLoading,
  } = useTabData<EDocuments>(type);

  return (
    <Container>
      <Loader isLoading={isFetching || isLoading} />
      {documents &&
        documents.documentBlocks.map((d) => (
          <DocumentList key={d.title} {...d} />
        ))}
    </Container>
  );
};

export default EDocument;
